import { render } from "./Studies.vue?vue&type=template&id=88d90db0"
import script from "./Studies.vue?vue&type=script&lang=js"
export * from "./Studies.vue?vue&type=script&lang=js"

import "./Studies.vue?vue&type=style&index=0&id=88d90db0&lang=css"

import exportComponent from "D:\\Projects\\DicomServerStudiesList\\DicomStudyListVueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer});
